import { render, staticRenderFns } from "./component-download.vue?vue&type=template&id=7d47ec79&scoped=true&"
import script from "./component-download.vue?vue&type=script&lang=js&"
export * from "./component-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d47ec79",
  null
  
)

export default component.exports